<template>
    <div>
        <div class="relative left-1/2 -ml-240 w-[1920px] mx-auto">
            <img src="~@/assets/img/topic/2023/spectrum-of-the-seas/banner.jpg" />
            <div class="absolute top-[614px] inset-x-0 ">
                <div class="flex bg-white w-300 mx-auto shadow">
                    <div class="flex-1 p-10">
                        <h1 class="text-[42px] font-semibold text-dark">超量子级豪华游轮</h1>
                        <ul class="grid grid-cols-3 gap-y-3 text-lg text-dark -mx-8 mt-5">
                            <li class="px-8"><span>总吨数</span> <span>16.8万</span></li>
                            <li class="px-8"><span>船长</span> <span>约348米</span></li>
                            <li class="px-8"><span>船宽</span> <span>约41米</span></li>
                            <li class="px-8"><span>载客量</span> <span>5064人</span></li>
                            <li class="px-8"><span>甲板</span> <span>16层</span></li>
                            <li class="px-8"><span>客房</span> <span>2124间</span></li>
                        </ul>

                        <div class="text-root mt-8">
                            2023年5月15日（上海）——皇家加勒比国际游轮（以下简称：皇家加勒比）今日宣布完成2024年国际游轮航线在华部署，旗下超大豪华游轮“海洋光谱号”将于2024年4月回归上海。皇家加勒比是在国家交通主管部门发布国际游轮复航试点方案，上海市政府通过推进游轮经济高质量发展三年行动计划之后，首家宣布重返中国市场的国际游轮头部企业。明年五一期间，皇家“海洋光谱号”将开启从上海出发的4晚5天至7晚8天前往周边国家的游轮度假航线，目的地涵盖东京、横滨、大阪、神户、福冈、长崎、熊本、鹿儿岛、冲绳等东北亚最热门的旅游胜地。7月起，皇家加勒比将在官网、微信小程序、呼叫中心全线开通航线查询和预定服务。
                        </div>
                    </div>
                    <div class="w-150 flex-shrink-0">
                        <v-player class="" :src="productstate.video" :cover="productstate.video_cover"
                            aspectRatio="600:400" />
                        <div class="px-15 py-5">
                            <img class="w-full h-auto" alt="Spectrum Of The Seas"
                                src="~@/assets/img/topic/2023/spectrum-of-the-seas/titlle.png" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="relative left-1/2 -ml-240 w-[1920px] mx-auto">
            <img alt="餐饮选择" src="~@/assets/img/topic/2023/spectrum-of-the-seas/module-1.png" />
        </div>
        <div :class="$style.facilities">
            <div class="main-width">
                <!-- <div class="title content-section">测试</div> -->
                <div :class="$style.head">
                    <div class="inline-block px-2 py-5">丰富的活动设施</div>
                </div>
                <div class="mt-18">
                    <ul class="flex" v-for="(items, index) in facilities" :key="index">
                        <li class="transition-all duration-300 relative" v-for="(item, itemIndex) in items"
                            :class="[activeIndexs[index] === itemIndex ? 'w-[550px]' : 'w-[218px]']" :key="itemIndex">
                            <div @mouseenter="setActiveIndexs(index, itemIndex)">
                                <el-image class="h-[490px] w-[550px !block" fit="cover" :src="item.image" />
                            </div>
                            <div class="absolute inset-0 pt-10 text-center text-white pointer-events-none">
                                <h4 class="text-2xl font-semibold">{{  item.title  }}</h4>
                                <Transition  name="el-fade-in-linear">
                                    <div v-if="activeIndexs[index] === itemIndex">
                                        <div class="w-16 h-0.5 bg-white mx-auto my-3"></div>
                                        <h5 class="text-base">{{  item.subtitle  }}</h5>
                                    </div>
                                </Transition>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="mt-16">
            <div :class="$style.head">
                <div class="inline-block px-2 py-5">舱房设施</div>
            </div>
            <div class="relative w-full mx-auto mt-18">
                <swiper class="swiper-no-swiping w-full !pb-[50px]" :options="swiperOptions">
                    <swiper-slide class="!w-[900px]" v-for="(img, index) in cabins" :key="index">
                        <div class="w-[900px] h-[522px] relative">
                            <img class="w-[900px] h-[522px] object-cover" :src="img" />
                        </div>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
                <button :class="$style.swiperButtonPrev" class="j_prev_btn" type="button">
                    <i class="ficon ficon-arrow-left text-dark leading-0"></i>
                </button>
                <button :class="$style.swiperButtonNext" class="j_next_btn" type="button">
                    <i class="ficon ficon-arrow-right text-dark leading-0"></i>
                </button>
            </div>
        </div>

        <div :class="$style.product_wraper">
            <div class="main-width">
                <div :class="$style.products">
                    <nuxt-link v-for="product in productstate.product" :key="product.product_no" :class="$style.product"
                        :to="`/product/automation/${product.product_no}`" target="_blank">
                        <el-image :class=$style.product_cover fit="cover" :src="product.image" />
                        <div :class="$style.product_content">
                            <h4 :class="$style.product_title">{{ product.name }}</h4>
                            <ul :class="$style.product_tags">
                                <li :class="$style.product_tag" v-for="(tag, index) in product.tags" :key="index">{{ tag }}
                                </li>
                            </ul>
                            <div :class="$style.product_price" class="font-medium">
                                <span class="text-2xl">¥</span>
                                <span class="text-4xl leading-tight">{{ product.price }}</span>
                                <span class="text-lg">起</span>
                            </div>

                            <div :class="$style.product_footer">
                                <div> <i class="el-icon-location-outline" /> <span class="text-dark">{{ product.departure
                                }}</span></div>
                                <button :class="$style.product_btn">查看详情</button>
                            </div>
                        </div>
                    </nuxt-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent, useFetch, computed, ref, useCssModule } from '@nuxtjs/composition-api';
import { getSpectrumDetail } from "@/services/special";

import useRequest from "@/composables/useRequest";
import VPlayer from "~/components/VPlayer/index.vue";

import IMG_FACILITIES_1 from '@/assets/img/topic/2023/spectrum-of-the-seas/facilities/img-1.jpg'
import IMG_FACILITIES_2 from '@/assets/img/topic/2023/spectrum-of-the-seas/facilities/img-2.jpg'
import IMG_FACILITIES_3 from '@/assets/img/topic/2023/spectrum-of-the-seas/facilities/img-3.jpg'
import IMG_FACILITIES_4 from '@/assets/img/topic/2023/spectrum-of-the-seas/facilities/img-4.jpg'
import IMG_FACILITIES_5 from '@/assets/img/topic/2023/spectrum-of-the-seas/facilities/img-5.jpg'
import IMG_FACILITIES_6 from '@/assets/img/topic/2023/spectrum-of-the-seas/facilities/img-6.jpg'
import IMG_FACILITIES_7 from '@/assets/img/topic/2023/spectrum-of-the-seas/facilities/img-7.jpg'
import IMG_FACILITIES_8 from '@/assets/img/topic/2023/spectrum-of-the-seas/facilities/img-8.jpg'



import IMG_CABIN_1 from 'assets/img/topic/2023/spectrum-of-the-seas/cabins/1完美家庭套房.jpg'
import IMG_CABIN_2 from 'assets/img/topic/2023/spectrum-of-the-seas/cabins/2豪华双层套房.jpg'
import IMG_CABIN_3 from 'assets/img/topic/2023/spectrum-of-the-seas/cabins/3豪华双层套房 1.jpg'
import IMG_CABIN_4 from 'assets/img/topic/2023/spectrum-of-the-seas/cabins/4豪华套房.jpg'
import IMG_CABIN_5 from 'assets/img/topic/2023/spectrum-of-the-seas/cabins/5金卡阳台套房.jpg'
import IMG_CABIN_6 from 'assets/img/topic/2023/spectrum-of-the-seas/cabins/6双人标准套房.jpg'
import IMG_CABIN_7 from 'assets/img/topic/2023/spectrum-of-the-seas/cabins/7豪华双人海景房.jpg'
import IMG_CABIN_8 from 'assets/img/topic/2023/spectrum-of-the-seas/cabins/8虚拟阳台双人内舱房.jpg'



import { chunk, throttle } from 'lodash';


const _facilities = [{
    image: IMG_FACILITIES_1,
    title: '北极星',
    subtitle: '360°俯瞰一望无际的蔚蓝海面'
}, {
    image: IMG_FACILITIES_2,
    title: '南极球',
    subtitle: '畅享蓝天碧海间的超凡体验'
}, {
    image: IMG_FACILITIES_3,
    title: '多功能运动馆',
    subtitle: '溜冰、碰碰车、击剑、电竞，运动无极限'
}, {
    image: IMG_FACILITIES_4,
    title: '甲板冲浪',
    subtitle: '甲板上纵情享受冲浪体验'
}, {
    image: IMG_FACILITIES_5,
    title: '皇家大道',
    subtitle: '海上最大的免税购物街'
}, {
    image: IMG_FACILITIES_6,
    title: '原创大秀',
    subtitle: '皇家王牌音乐舞蹈大秀一次看个够'
}, {
    image: IMG_FACILITIES_7,
    title: '海上历奇',
    subtitle: '覆盖3岁-17岁儿童娱乐项目'
}, {
    image: IMG_FACILITIES_8,
    title: '日光浴场',
    subtitle: '沐浴海上阳光，尽享私密时光'
}]


const cabins = [
    IMG_CABIN_1,
    IMG_CABIN_2,
    IMG_CABIN_3,
    IMG_CABIN_4,
    IMG_CABIN_5,
    IMG_CABIN_6,
    IMG_CABIN_7,
    IMG_CABIN_8,
]

export default defineComponent({
    name: 'SpectrumOfTheSeas',
    components: { VPlayer },
    head: {
        title: '海洋光谱号'
    },
    setup() {

        let { state: productstate, execute } = useRequest(() => getSpectrumDetail(), {
            product: [],
            video: "",
            video_cover: "",
        }, {
            immediate: false,
        });
        const activeIndexs = ref([0, 1]);
        const setActiveIndexs = (rowIndex, colIndex) => {
            activeIndexs.value.splice(rowIndex, 1, colIndex)
        }
        // onMounted(async () => {
        //     console.log('onMounted')
        //     const res= await getSpectrumDetail();
        //     console.log(res)
        // })
        useFetch(async () => {
            const res = await execute(0);
            console.log(res)
        });

        const facilities = computed(() => chunk(_facilities, 4))

        const classes = useCssModule()
        const swiperOptions = {
            loop: true,
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 68,
            navigation: {
                prevEl: '.j_prev_btn',
                nextEl: '.j_next_btn',
            },
            pagination: {
                el: '.swiper-pagination',
                cliceable: true
            }
        }
        return {
            productstate,
            facilities,
            activeIndexs,
            setActiveIndexs,

            cabins,
            swiperOptions
        }
    }
})
</script>

<style lang="scss" module>
.facilities {
  background-position: bottom;
  background-repeat: no-repeat;
  height: 1246px;
  background-image: url('~@/assets/img/topic/2023/spectrum-of-the-seas/module-2-bg.png');
  background-size: 1920px auto;
}
.swiperButtonNext, .swiperButtonPrev {
  font-size: 2.25rem;
  line-height: 2.5rem;
  position: absolute;
  top: 50%;
  z-index: 10;
  transform: translateY(-50%);
}
.swiperButtonPrev {
  margin-left: -500px;
  left: 50%;
}
.swiperButtonNext {
  margin-left: 470px;
  left: 50%;
}
.product {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 0.125rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  margin-top: 2.75rem;
  margin-bottom: 2.75rem;
  overflow: hidden;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
}
.product_cover {
  height: 20rem;
  width: 30.75rem;
}
.product_content {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
  overflow: hidden;
  padding-left: 3rem;
  padding-right: 3rem;
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.product_title {
  font-weight: 500;
  font-size: 1.625rem;
  line-height: 1.25;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.product_tags {
  margin-top: 1.25rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.product_tag {
  --tw-bg-opacity: 1;
  background-color: rgba(233, 243, 252, var(--tw-bg-opacity));
  border-radius: 0.25rem;
  display: inline-block;
  font-size: 1rem;
  line-height: 1.5rem;
  line-height: 1.25;
  margin-right: 0.75rem;
  margin-top: 0.5rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.product_price {
  line-height: 1.25;
  margin-top: 1.25rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.product_price_num {
  font-size: 1.625rem;
  line-height: 1.25;
}
.product_footer {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  font-size: 1.125rem;
  line-height: 1.75rem;
  margin-top: 1rem;
}
.product_btn {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 94, 220, var(--tw-bg-opacity));
  border-radius: 9999px;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.head {
  font-weight: 700;
  font-size: 40px;
  line-height: 1;
  line-height: 1.5;
  padding-bottom: 23px;
  position: relative;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.head::after {
  content: "";
  transform: translateX(-50%);
  background: linear-gradient(270deg, #005EDC 0%, #1A00DC 26%, #D1DC00 55%, #FF884D 79%);
  height: 0.25rem;
  position: absolute;
  left: 50%;
  bottom: 3px;
  width: 280px;
}
.product_wraper {
  background: url('~@/assets/img/topic/2023/spectrum-of-the-seas/module-3-bg.png') top center no-repeat;
  background-size: 1920px auto;
  padding-top: 278px;
}
</style>